import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ScrollToTop from "@/components/ScrollToTop";
import { STATIONERY_NAV } from "@/lib/stationeryNav";

// Code-split all non-home routes — speeds up initial mobile LCP
const About = lazy(() => import("@/pages/About"));
const Team = lazy(() => import("@/pages/Team"));
const Services = lazy(() => import("@/pages/Services"));
const Portfolio = lazy(() => import("@/pages/Portfolio"));
const Contact = lazy(() => import("@/pages/Contact"));
const Book = lazy(() => import("@/pages/Book"));
const ExpressDelhi = lazy(() => import("@/pages/ExpressDelhi"));
const Career = lazy(() => import("@/pages/Career"));
const StationeryLanding = lazy(() => import("@/pages/StationeryLanding"));
const NotFound = lazy(() => import("@/pages/NotFound"));
const Journal = lazy(() => import("@/pages/Journal"));
const JournalArticle = lazy(() => import("@/pages/JournalArticle"));

const PageFallback = () => (
  <div style={{ minHeight: "60vh", background: "#0E0709" }} />
);

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={<PageFallback />}>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/team" element={<Team />} />
                <Route path="/services" element={<Services />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/book" element={<Book />} />
                <Route path="/express-delhi-ncr" element={<ExpressDelhi />} />
                <Route path="/career" element={<Career />} />
                <Route path="/careers" element={<Career />} />
                {STATIONERY_NAV.map(({ slug }) => (
                  <Route key={slug} path={`/${slug}`} element={<StationeryLanding slug={slug} />} />
                ))}
                <Route path="/journal" element={<Journal />} />
                <Route path="/journal/:slug" element={<JournalArticle />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </Suspense>
        </BrowserRouter>
      </HelmetProvider>
      <Toaster position="bottom-center" richColors theme="dark" />
    </div>
  );
}

export default App;
